import { ModalDialog } from '@vp/swan'
import { useEffect, useRef } from 'react'
import { useUploadsStore } from '../../UploadsProvider'
import { useSchemeUploads } from '../../../Schemes/hooks/useSchemeUploads'
import { SCHEME_KEYS, usePersonalizationManager } from '../../PersonalizationManager'
import { UploadsModalContent } from './UploadsModalContent'

export interface UploadsModalProps {
  handleSubmit: () => void
  handleSignIn: () => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export const UploadsModal = (props: UploadsModalProps) => {
  const { handleSubmit, handleSignIn, isOpen, setIsOpen } = props

  const { uploads } = useSchemeUploads(SCHEME_KEYS.MANUAL)
  const { setSelectedUploads } = useUploadsStore()
  const { tracking } = usePersonalizationManager()

  // TODO: Move into hook. Logic duplicaed in PersonalizationModal
  const hasInitializedUploads = useRef(false) // used to block reruns

  useEffect(() => {
    if (isOpen && uploads.length > 0 && !hasInitializedUploads.current) {
      hasInitializedUploads.current = true // prevent reruns
      setSelectedUploads(uploads)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploads, isOpen])

  const handleDialogClose = (): void => {
    // This fires whenever the modal closes, including when uploads are submitted
    tracking.uploadsModalClosed()
    hasInitializedUploads.current = false
    setIsOpen(false)
  }

  return (
    <ModalDialog
      onlyRenderWhenOpen
      bodyWidth="capped"
      className="personalization-image-modal"
      isOpen={isOpen}
      variant="panel-right"
      onRequestDismiss={handleDialogClose}
    >
      <UploadsModalContent handleClose={(): void => setIsOpen(false)} handleSignIn={handleSignIn} handleSubmit={handleSubmit} isOpen={isOpen} />
    </ModalDialog>
  )
}
